"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4061],{

/***/ 4061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M20 12.6004V6.40039C20 4.70039 18.7 3.40039 17 3.40039H7C5.3 3.40039 4 4.70039 4 6.40039V12.6004C2.8 13.0004 2 14.1004 2 15.4004V21.4004C2 22.0004 2.4 22.4004 3 22.4004C3.6 22.4004 4 22.0004 4 21.4004V20.4004H20V21.4004C20 22.0004 20.4 22.4004 21 22.4004C21.6 22.4004 22 22.0004 22 21.4004V15.4004C22 14.1004 21.2 13.0004 20 12.6004ZM6 6.40039C6 5.80039 6.4 5.40039 7 5.40039H17C17.6 5.40039 18 5.80039 18 6.40039V12.4004H16V8.40039C16 7.80039 15.6 7.40039 15 7.40039H9C8.4 7.40039 8 7.80039 8 8.40039V12.4004H6V6.40039ZM14 12.4004H10V9.40039H14V12.4004ZM4 18.4004V15.4004C4 14.8004 4.4 14.4004 5 14.4004H9H15H19C19.6 14.4004 20 14.8004 20 15.4004V18.4004H4Z"
}), "RoomOnly"));


/***/ })

}]);